import {useQuery} from '@tanstack/react-query'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {getActiveDeviceByGender, getUserStatistics} from '../ServiceWorker'

export const useListActiveDeviceByGender = (
    requestorId,
    hospitalId,
    enabled = true,
) => {
    const {chartKeys} = QueryKeyManager(QueryKeyTypes.chart, requestorId)

    return useQuery({
        queryKey: chartKeys.activeDevice({
            hospitalId,
        }),
        queryFn: () => getActiveDeviceByGender(),
        enabled: !!requestorId && !!enabled,
    })
}

export const useListUserStatistic = (
    requestorId,
    hospitalId,
    year,
    enabled = true,
) => {
    const {chartKeys} = QueryKeyManager(QueryKeyTypes.chart, requestorId)

    return useQuery({
        queryKey: chartKeys.userStatistic({
            hospitalId,
            year,
        }),
        queryFn: () => getUserStatistics(requestorId, hospitalId, year),
        enabled: !!requestorId && !!enabled,
    })
}
